module.exports = __webpack_public_path__ + "img/3_s-title.f181cd4c.gif";